import type React from 'react';
import MarkFeatureCard from './mark-feature-card';
import Icons from 'assets/icons';

const FEATURE_CARDS = [
  {
    icon: Icons.LineGraph,
    title: 'Track Critical Elements',
    description:
      'Track year-over-year shifts in deposits, applicants, and yield at a glance.',
  },
  {
    icon: Icons.ChartsVerticalBar,
    title: 'Benchmark against the market',
    description:
      'See how your volume builds, rates, and proportions compare to peer and regional cohorts across any student segment.',
  },
  {
    icon: Icons.Funnel,
    title: 'Analyze funnel performance',
    description:
      'Track inquiry conversion, uncover drop-off points, and catch melt before it grows.',
  },
  {
    icon: Icons.Profile2,
    title: 'Report to stakeholders',
    description:
      'Surface the right numbers at the right time — ready to share.',
  },
];

const MarkWalkthroughStep1 = (): React.JSX.Element => (
  <div className="flex-1 flex flex-col items-center gap-4 pt-4">
    <Icons.MarkLogo className="size-20" role="img" aria-label="MARK" />

    <div className="flex flex-col items-center gap-1 text-center">
      <h2 className="text-2xl font-bold text-navy-800">
        Meet MARK - Your on-demand analyst.
      </h2>
      <p className="text-base text-gray-700">
        Ask MARK your data questions and it keeps you informed on the metrics
        that matter most to your success.
      </p>
    </div>

    <div className="grid w-full grid-cols-1 gap-4 tablet:grid-cols-2">
      {FEATURE_CARDS.map((card) => (
        <MarkFeatureCard
          key={card.title}
          icon={card.icon}
          title={card.title}
          description={card.description}
          className="min-h-[142px]"
        />
      ))}
    </div>
  </div>
);

export default MarkWalkthroughStep1;
